import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { LoaderService } from '../../../shared/services';

/**
 * Global loading overlay. Binds to loaderService.status via async pipe
 * so no template-bound mutation occurs in subscriptions (avoids NG0100).
 */
@Component({
  selector: 'app-loading-screen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent {
  /** Exposed for template *ngIf; async pipe handles subscription and CD. */
  readonly loaderStatus$: Observable<boolean>;

  constructor(public loaderService: LoaderService) {
    this.loaderStatus$ = this.loaderService.status;
  }
}
